import React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import styled from 'styled-components';
import { LFC } from '../../Legacy';
import { Fill } from '../../ui/Fill';
import { FlexFrame } from '../dashboard/elements/LayoutElements';

const XScrollbars = Scrollbars as any;

const Base = styled.div`
    position: relative;
    width: 32rem;
    height: 16rem;
`;

const LeftInner = styled.div`
    flex: 0 0 12rem;
`;

const Left: LFC = ({ children }) => {
    return <XScrollbars style={{ 'height': '100%' }}>
        <FlexFrame flex="row">
            <LeftInner>
                {children}
            </LeftInner>
        </FlexFrame>
    </XScrollbars>;
};

const RightInner = styled.div`
    flex: 1 1 auto;
    border-left: solid 1px #e4e8ee;
    margin-left: 12rem;
    margin-right: .5rem;
    pointer-events: all;
`;

const Right: LFC = ({ children }) => {
    return <Fill flex="row" pointerEvents="none">
        <RightInner>
            {children}
        </RightInner>
    </Fill>;
};

export const AnchoredScroller = Object.assign(Base, { Left, Right });
